var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"100%","width":"100%"},attrs:{"tile":"","outlined":"","flat":""}},[_vm._v(" "+_vm._s(_vm.error ? 'Сервис временно недоступен.' : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }